export interface ItemDaGrade {
  rotulo: string;
  titulo: string;
  texto: string;
}

interface Props {
  id?: string;
  rotulo: string;
  titulo: string;
  itens: ItemDaGrade[];
}

export function Grade({ id, rotulo, titulo, itens }: Props) {
  return (
    <section id={id} className="lp-secao">
      <p className="lp-rotulo lp-rotulo-ponto">{rotulo}</p>
      <h2 className="lp-secao-titulo">{titulo}</h2>

      <div className="lp-grade">
        {itens.map((i) => (
          <article key={i.rotulo} className="lp-item">
            <p className="lp-rotulo">{i.rotulo}</p>
            <h3 className="lp-item-titulo">{i.titulo}</h3>
            <p className="lp-item-texto">{i.texto}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
